import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

type CustomerServiceCardProps = {
  hoverIcon: string;
  icon: string;
  label: string;
  link: string;
};

export default function CustomerServiceCard(props: CustomerServiceCardProps) {
  const { hoverIcon, icon, label, link } = props;

  return (
    <Link passHref href={link}>
      <div className="w-48 group bg-supportCardBackground py-12 px-4 flex flex-col rounded-xl space-y-3 hover:bg-primaryBlue hover:text-white cursor-pointer">
        <div className="group-hover:hidden block">
          <Image alt="Icon" height={80} src={icon} width={80} />
        </div>
        <div className="group-hover:block hidden group-hover:mt-0">
          <Image alt="Icon" height={80} src={hoverIcon} width={80} />
        </div>
        <small className="font-MuseoSans500">{label}</small>
      </div>
    </Link>
  );
}
